<template>
  <b-navbar toggleable="md" id="header" sticky class="text-center">
    <router-link id="logo" :to="{ name: 'AdminGroups' }" class="navbar-brand" v-if="currentUser.admin && (adminCurrentView === 'admin')">
      <img src="/img/logos/logo_color.png" id="logo" />
    </router-link>
    <router-link id="logo" :to="{ name: 'UserDashboard' }" class="navbar-brand" v-else>
      <img src="/img/logos/logo_color.png" id="logo" />
    </router-link>

    <b-navbar-toggle target="nav-collapse" />
    <b-collapse id="nav-collapse" is-nav>
      <div id="nav" v-if="!currentUser"></div>
      <b-navbar-nav>
        <b-nav-item-dropdown @mouseover.native="onOver('quick-tour-dropdown')" @mouseleave.native="onLeave('quick-tour-dropdown')" ref="quick-tour-dropdown" text="QUICK TOUR" class="nav-item" id="quick-tour-header" v-if="currentUser.admin || isGroupManager">
          <b-dropdown-item :to="{ name: 'QuickTour', params: {type: 'presenter'} }">
            Presenter
          </b-dropdown-item>
          <b-dropdown-item :to="{ name: 'QuickTour', params: {type: 'group-manager'} }" v-if="currentUser.admin || isGroupManager">
            Group Manager
          </b-dropdown-item>
          <b-dropdown-item :to="{ name: 'QuickTour', params: {type: 'org-admin'} }" v-if="currentUser.admin">
            Organizational Admin
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <router-link :to="{ name: 'QuickTour', params: {type: 'presenter'}  }" class="nav-item" id="quick-tour-header" v-else>
          QUICK TOUR
        </router-link>
        <router-link :to="{ name: 'UserResources' }" class="nav-item">
          ALL RESOURCES
        </router-link>

        <b-nav-item-dropdown
          text="ACTION STEPS" class="nav-item" id="action-steps-header"
          @mouseover.native="onOver('action-steps-header')"
          @mouseleave.native="onLeave('action-steps-header', true)"
          ref="action-steps-header"
        >
          <b-dropdown-item
            v-for="(area, index) in Object.keys(actionSteps)"
            :key="area"
            class="submenu-wrapper"
            @click.native.capture.stop="checkLink($event)"
            @mouseover.native="showNextArea($event, 'action-steps-area', index, Object.keys(actionSteps).length)"
          >
            {{area}}
            <div class="submenu" v-if="Object.keys(actionSteps[area]).length" :ref="`action-steps-area-${index}`">
              <b-dropdown-item
                v-for="(subarea, ind) in Object.keys(actionSteps[area])"
                :key="subarea"
                class="submenu-wrapper"
                @mouseover.native="showNextArea($event, `action-steps-subarea-${index}`, ind, Object.keys(actionSteps[area]).length)"
              >
                {{subarea}}
                <div class="submenu nested" v-if="Object.keys(actionSteps[area][subarea]).length" :ref="`action-steps-subarea-${index}-${ind}`">
                  <b-dropdown-item v-for="dest in Object.keys(actionSteps[area][subarea])" :key="dest" :data-link="actionSteps[area][subarea][dest]">
                    {{dest}}
                  </b-dropdown-item>
                </div>
              </b-dropdown-item>
            </div>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <organization-logo :organizationInfo="organizationInfo"></organization-logo>
      <b-navbar-nav class="ml-auto">
        <div id="user-background">
          <div id="user-toggle-menu">
            <span id="icon"
              ><img
                src="../../../public/img/icons/avatar_dash@2x.png"
                width="15"
                height="17"
            /></span>
            <b-dropdown
              id="dropdown-1"
              :text="currentUser.full_name"
              ref="dropdown"
              class="m-md-2"
            >
              
              <router-link :to="{ name: 'Account' }" id="account-info" >
                Account Information
              </router-link>
              <a
                v-if="currentUser.admin && (adminCurrentView === 'admin' || !adminCurrentView)"
                @click="handleAdminViewSwitch('presenter')"
                id="admin-presenter-view-switch" 
              >
                Switch to Presenter View
              </a>
              <a
                v-if="currentUser.admin && (adminCurrentView === 'presenter')"
                @click="handleAdminViewSwitch('admin')"
                id="admin-groups-view-switch"
              >
                Switch to Admin View
              </a>
              <TMGeneralButton
                id="logout"
                text="SIGN OUT"
                route="LogOut"
                className="yellow"
              />
            </b-dropdown>
          </div>
        </div>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import TMGeneralButton from "@/components/common/TMGeneralButton";
import OrganizationLogo from "@/components/common/OrganizationLogo";
import store from '@/store'

export default {
  name: "DashHeader",
  components: {
    TMGeneralButton,
    OrganizationLogo
  },
  data: () => ({
    organizationInfo: null,
    actionSteps: store.state.actionSteps,
  }),
  computed: {
    ...mapState(["currentUser", "adminCurrentView"]),
    ...mapGetters(["isGroupManager"])
  },
  mounted() {
    this.organizationInfo = this.currentUser.organization;
  },
  methods: {
    ...mapActions(["LOG_OUT", "UPDATE_ADMIN_CURRENT_VIEW"]),
    onOver(type) {
      this.$refs[type].visible = true;
    },
    onLeave(type, closeSubmenus) {
      this.$refs[type].visible = false;
      if (closeSubmenus) {
        this.closeAllSubmenus();
      }
    },
    showNextArea(e, area, index, len) {
      e.preventDefault();
      e.stopPropagation();

      for (let i = 0; i < len; i++) {
        this.$refs[`${area}-${i}`][0].style.display = "none";
      }

      this.$refs[`${area}-${index}`][0].style.display = "block";
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    closeAllSubmenus() {
      for (let i = 0; i < Object.keys(this.actionSteps).length; i++) {
        this.$refs[`action-steps-area-${i}`][0].style.display = "none";

        for (let j = 0; j < Object.keys(this.actionSteps[Object.keys(this.actionSteps)[i]]).length; j++) {
          this.$refs[`action-steps-subarea-${i}-${j}`][0].style.display = "none";
        }
      }
    },
    checkLink(ev) {
      if (ev.target.dataset.link) {
        this.openLink(ev.target.dataset.link)
      }
    },
    handleAdminViewSwitch(nextView) {
      this.UPDATE_ADMIN_CURRENT_VIEW(nextView)
      if (nextView === 'presenter') {
        this.$router.push({ name: 'UserDashboard' })
      } else if (nextView === 'admin') {
        this.$router.push({ name: 'AdminGroups' })
      }
    }
  },
  watch: {
    currentUser(value) {
      if (!this.currentUser) {
        this.$router.push({ name: "Home" });
      }
      this.organizationInfo = value.organization;
    },
  },
};
</script>
<style lang="less" >
@import "../../assets/common/DashHeader.less";
.submenu-wrapper {
  position: relative;
}
.submenu { 
  display: none;
  position: absolute;
  left:100%;
  top: -7px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  z-index: 3;
  box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.2); /* Adjust the values for your desired shadow effect */
}
.submenu.nested {
  top: 0;
  z-index: 4;
}
</style>